import { Button } from '@mantine/core';
import { IconPlus } from '@tabler/icons-react';
import { tKeys, useTranslation } from 'locales';

export const CreateButton = ({
  label,
  ...props
}: React.ComponentProps<typeof Button> &
  React.HTMLAttributes<HTMLButtonElement> & { label?: string }) => {
  const { t } = useTranslation();

  return (
    <Button leftSection={<IconPlus stroke={1.5} />} {...props}>
      {label ?? t(tKeys.NEW)}
    </Button>
  );
};
